export default __webpack_public_path__ + "static/media/add-button.3d27a391.svg";